/* Copyright (c) 2020-present CloudIO Inc */

import { makeStyles } from '@mui/styles';
import React from 'react';
import WaveDots from 'utils/WaveDots';

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
  },
}));

export default function SimpleLoading({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  name,
}: {
  name?: string;
}): React.ReactElement {
  const classes = useStyles();
  // console.log('Suspense.render', name);
  // React.useEffect(() => {
  //   console.log('Suspensed', name);
  //   return () => {
  //     console.log('Suspense', name, 'complete');
  //   };
  // }, [name]);
  return (
    <div className={classes.root}>
      <WaveDots active reason={`Suspensed: ${name}`} />
    </div>
  );
}
